export const UncloakingIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='1'>
        <path
          d='M5.9987 11.6667H2.33203M4.33203 8H1.33203M5.9987 4.33333H2.66536M11.332 2L6.93443 8.15667C6.73976 8.4292 6.64244 8.5654 6.64666 8.679C6.65032 8.77793 6.69776 8.87007 6.7761 8.93053C6.8661 9 7.0335 9 7.36843 9H10.6654L9.9987 14L14.3963 7.84333C14.591 7.5708 14.6883 7.4346 14.6841 7.321C14.6804 7.22207 14.633 7.12993 14.5546 7.06947C14.4646 7 14.2972 7 13.9623 7H10.6654L11.332 2Z'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
